import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ff5a766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rate-us" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Like using us?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ion_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_title, null, {
          default: _withCtx(() => [
            _createTextVNode("Rate us on PlayStore")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_buttons, { style: {"justify-content":"center"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              href: "https://play.google.com/store/apps/details?id=doorieteach.app.com",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: $setup.star
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              href: "https://play.google.com/store/apps/details?id=doorieteach.app.com",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: $setup.star
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              href: "https://play.google.com/store/apps/details?id=doorieteach.app.com",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: $setup.star
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              href: "https://play.google.com/store/apps/details?id=doorieteach.app.com",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: $setup.star
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              href: "https://play.google.com/store/apps/details?id=doorieteach.app.com",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: $setup.star
                }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}